<template>
  <div class="app-footer flex p2">
    <div>
      <a class="btn mx0" :href="developerUrl" target="_blank">
        {{developer}}
        <br/>
        {{$app.build}}
      </a>
    </div>
    <div class="flex-auto">
    </div>
    <div v-show="$auth.logged">
      <span class="btn btn-primary" @click="$faleConosco.show()">
        <i class="material-icons">mail</i>
        Fale Conosco
      </span>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    developer: function () {
      return this.$app.instance.developer.name || 'box00'
    },
    developerUrl: function () {
      return this.$app.instance.developer.url || 'https://box00.com'
    }
  }
}
</script>
